import React from "react";
import { useHistory } from "react-router-dom";

import { Security } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";
import AppWithRouterAccess from "./modules/Auth/pages/AppWithRouterAccess";

export function Routes() {
  // const { isAuthorized } = useSelector(
  //   ({ auth }) => {
  //     return ({
  //       isAuthorized: auth.user != null,
  //       pageAuth: auth.pageAuth
  //     });
  //   },
  //   shallowEqual
  // );

  const history = useHistory();
  const onAuthRequired = () => {
    history.push("/login");
  };

  const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_DOMAIN,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: window.location.origin + "/login/callback",
    onAuthRequired: onAuthRequired,
    pkce: true,
  });

  return (
    <Security oktaAuth={oktaAuth}>
      <AppWithRouterAccess />
    </Security>
  );
}
